import { Injectable } from '@angular/core';
import {AuthService, IdToken} from '@auth0/auth0-angular';
import {HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Observable} from "rxjs";
import {mergeMap} from "rxjs/operators";

@Injectable()
export class MyAuthHttpInterceptor implements HttpInterceptor {

  constructor(auth:AuthService) {
    console.log('interceptou')
    auth.isAuthenticated$.subscribe( r=> {
      if(r) {
        auth.idTokenClaims$.subscribe(r => {
          window.localStorage.setItem("token", JSON.stringify(r))
          const agencia = r["agencia"]
          localStorage.setItem("agencia", agencia)
        })
      }
    })
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const raw_token = localStorage.getItem("token")
    const token = JSON.parse(raw_token!!) as IdToken
    console.log('token usado',token)
    return next.handle(req.clone({setHeaders:  {'Authorization': `Bearer ${token.__raw}`}}));
  }

}
